import { render, staticRenderFns } from "./QcCommerce.vue?vue&type=template&id=5f40110a&scoped=true"
import script from "./QcCommerce.vue?vue&type=script&lang=js"
export * from "./QcCommerce.vue?vue&type=script&lang=js"
import style0 from "./QcCommerce.vue?vue&type=style&index=0&id=5f40110a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40110a",
  null
  
)

export default component.exports